<template>
  <!-- 基础弹窗组件 -->
  <transition name="fade" mode="out-in">
    <div :class="['popup', popupClass]" v-show="visible">
      <div
        class="popup-mask"
        @click="maskClosable ? handleClose() : null"
      ></div>
      <div class="popup-content">
        <!-- 关闭按钮 -->
        <div
          v-if="showCloseBtn"
          :class="closeBtnClass"
          @click="handleClose"
        ></div>

        <!-- 标题区域 -->
        <div v-if="title || $slots.title" class="popup-title">
          <div class="popup-title-text">
            <slot name="title">{{ title }}</slot>
          </div>
        </div>

        <!-- 内容区域 -->
        <div class="content-area">
          <slot></slot>
        </div>

        <!-- 底部区域 -->
        <div v-if="$slots.footer" class="popup-bottom">
          <slot name="footer"></slot>
        </div>

        <!-- 底部吉祥物 -->
        <div class="popup-bottom-boli"></div>
      </div>
      <div class="popup-close-btn-mobile" @click="handleClose">
        <div class="popup-close-btn-mobile-icon"></div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

// 定义props
const props = defineProps({
  // 控制显示/隐藏
  visible: {
    type: Boolean,
    default: false,
  },
  // 弹窗的自定义class
  popupClass: {
    type: String,
    default: "",
  },
  // 标题
  title: {
    type: String,
    default: "",
  },
  // 是否显示标题图标
  showTitleIcon: {
    type: Boolean,
    default: false,
  },
  // 是否显示关闭按钮
  showCloseBtn: {
    type: Boolean,
    default: true,
  },
  // 关闭按钮的class
  closeBtnClass: {
    type: String,
    default: "popup-close-btn",
  },
  // 点击遮罩是否可以关闭
  maskClosable: {
    type: Boolean,
    default: true,
  },
});

// 定义emits
const emit = defineEmits(["close", "update:visible"]);

// 关闭弹窗
const handleClose = () => {
  emit("close");
  emit("update:visible", false);
};
</script>

<style scoped>
/* 基础样式可以在这里定义，但通常样式会在全局less文件中 */
</style>
